import React, { useState } from 'react';
import './CommonDropArea.css';
import drag_and_drop from '../../images/drag_and_drop.png';

export interface ISetFileCallback {
    onSetFile: (files: FileList) => void;
    onFailure: (err: string) => void;
}

export type DropAreaProp = {
    callbacks: ISetFileCallback;
    loading: boolean;
    // message: string | undefined;
}

type Props = {
    prop: DropAreaProp
}

export const CommonDropArea: React.FC<Props> = ({prop}) => {

    const [draging, setDraging] = useState<boolean>(false);

    const drop = (event: React.DragEvent<HTMLDivElement>) => {
        setDraging(false);
        event.preventDefault();
        console.log(
            'drop: ',
            event, event.dataTransfer.types, event.dataTransfer.files);
        if (prop.loading) {
            // 処理中はエラー（onDragOverで受け付けないようにはしているが念のため）
            console.log('drop: now loading');
            prop.callbacks.onFailure('Now loading!');
            return;
        }
        if (event.dataTransfer.files) {
            const file : File = event.dataTransfer.files[0];
            prop.callbacks.onSetFile(event.dataTransfer.files);    
        }
    }

    const areaClass = () => {
        if (prop.loading) {
            return "Common_drop_area Common_drop_area_disable";
        }

        if (draging) {
            return "Common_drop_area Common_drop_area_drag";
        }
        return "Common_drop_area";
    }

    return (
        <div
            className={areaClass()}
            onDrop={drop}
            onDragEnter={(e) => {
                setDraging(true);
            }}
            onDragLeave={(e) => {
                setDraging(false);
            }}
            onDragOver={(e) => {
                e.preventDefault(); // これがないとdropイベントが発火しない

                // 処理中(prop.loading=true)はドロップを受け付けない(dropEffect=none)ようにする
                const effectBefore = e.dataTransfer.dropEffect;
                e.dataTransfer.dropEffect = prop.loading ? "none" : "copy";
                console.log(
                    'onDragEnter: loading=' + prop.loading +
                    ', effectBefore=' + effectBefore + "->" + e.dataTransfer.dropEffect);
                //console.log('onDragOver:', e);
            }}
        >
            {
                prop.loading &&
                (
                    <div className="Common_drop_area_loader"></div>
                )
            }
            <img src={drag_and_drop} />
            {/* <span>Drag and drop the Excel file here to update the file.</span> */}
            <div className='Common_drop_area_discription'>Drag and drop the Excel file here to update the file.</div>
            {/* {prop.message} */}
        </div>
    );
};
    